var classes = {"modalRoot":"TQI56","featureModalContentWrapper":"EYeYV","featureModalContentBlockWrapper":"e7m2M","blockWithImage":"Rdhf8","blockWithoutImage":"ytWg9"};

export { classes as default };
